import { ChainalysisAddressInfoSearchResponseMetadata } from "~/endpoints/integrations/types/chainalysis";
import { Owner } from "~/endpoints/integrations/types/coinfirm";
import { EllipticAddressInfoSearchResponseMetadata } from "~/endpoints/integrations/types/elliptic";
import { TagInfo } from "~/endpoints/integrations/types/merklescience";

export function coinfirmAdditionalInfo(owner: Owner | undefined): string {
  if (owner) {
    return [
      `${owner?.name && "name: "}`,
      owner?.name,
      `${owner?.url && "\nurl: "}`,
      owner?.url,
      `${(owner?.owner_legal_name || owner?.legal_entity_name) && "\nlegal_name: "}`,
      owner?.owner_legal_name || owner?.legal_entity_name,
    ].join("");
  }
  return "";
}

export function chainalysisAdditionalInfo(
  chainalysisResponse: ChainalysisAddressInfoSearchResponseMetadata | undefined,
) {
  if (chainalysisResponse) {
    return [
      [chainalysisResponse?.cluster?.category, chainalysisResponse?.cluster?.name].filter(Boolean).join(": "),
      [
        chainalysisResponse?.customAddress?.categoryName,
        chainalysisResponse?.customAddress?.addressName,
        chainalysisResponse?.customAddress?.description,
      ]
        .filter(Boolean)
        .join(" - "),
      [
        chainalysisResponse?.chainalysisIdentification?.addressName,
        chainalysisResponse?.chainalysisIdentification?.addressName,
        chainalysisResponse?.chainalysisIdentification?.description,
      ]
        .filter(Boolean)
        .join(" - "),
    ]
      .filter(Boolean)
      .join("\n");
  }

  return "";
}

export function merkleScienceAdditionaInfo(merkleScienceResponse: TagInfo | undefined) {
  if (merkleScienceResponse) {
    return [
      `${merkleScienceResponse?.tag_name_verbose && "name: "}`,
      merkleScienceResponse?.tag_name_verbose,
      `${merkleScienceResponse?.tag_type_verbose && "\ncategory: "}`,
      merkleScienceResponse?.tag_type_verbose,
    ].join("");
  }

  return "";
}

export function ellipticAdditionalInfo(
  ellipticOriginatorResponse: EllipticAddressInfoSearchResponseMetadata | undefined,
) {
  if (ellipticOriginatorResponse?.category && ellipticOriginatorResponse?.name) {
    return [`${ellipticOriginatorResponse?.category}:`, ellipticOriginatorResponse?.name].join(" ");
  }
  return "";
}
